<template>
  <div id="allIsoform" class="mt-2">
    <svg></svg>
    <div class="d-flex justify-center">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="zoomin mr-3" color="info" x-small fab v-bind="attrs" v-on="on">
            <v-icon small>mdi-plus-circle-outline</v-icon>
            <!-- <span class="font-weight-bold">Zoom in</span> -->
          </v-btn>
        </template>
        <span>zoom in</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="zoomout mr-3" color="info" x-small fab v-bind="attrs" v-on="on">
            <v-icon small>mdi-minus-circle-outline</v-icon>
            <!-- <span class="font-weight-bold">Zoom out</span> -->
          </v-btn>
        </template>
        <span>zoom out</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="reset mr-3" color="info" x-small fab v-bind="attrs" v-on="on">
            <v-icon small>mdi-reply</v-icon>
            <!-- <span class="font-weight-bold">Reset</span> -->
          </v-btn>
        </template>
        <span>reset</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="reset mr-3" color="info" x-small fab v-bind="attrs" v-on="on" style="cursor: auto">
            <v-icon>mdi-help</v-icon>
          </v-btn>
        </template>
        <span class="red--text font-weight-bold">Tips:</span><br />
        <span>Double-click: zoom in</span><br />
        <span>Single-click: reset</span><br />
        <span>Press and hold down the left mouse: drag</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="download mr-3" color="info" @click="downloadTranscript" x-small fab v-bind="attrs" v-on="on">
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>
        <span>download</span><br />
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import tippy, { followCursor } from "tippy.js";
import "tippy.js/dist/tippy.css";
import { getGencodeGenePatternByGenename } from "node/details";

export default {
  name: "GeneTranscriptStructure",
  props: {
    geneName: {
      type: String,
      default() {
        return;
      },
    },
  },
  data() {
    return {
      gene_select: null,

      gencodeGenePattern: [],
      gene_start: null,
      gene_end: null,
      strand: null,
      transcript: [],
      all_tx_exon: [],
      all_tx_intron: [],
      all_tx_utr: [],
      all_start_codon: [],
      all_stop_codon: [],
    };
  },
  created() {
    // Load external svg2pdf js scripts
    const script1 = document.createElement("script");
    script1.type = "text/javascript";
    script1.src =
      "https://ngdc.cncb.ac.cn/ascancer/api/js/pdfkit.standalone.js";
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.src = "https://ngdc.cncb.ac.cn/ascancer/api/js/svg-to-pdfkit.js";
    document.body.appendChild(script2);
  },
  watch: {
    geneName(newVal, oldVal) {
      // console.log(newVal);
      this.gene_select = newVal;
      this.getGencodeGenePatternByGenename();
      this.initTxStructure();
    },
  },
  methods: {
    async getGencodeGenePatternByGenename() {
      let genename;
      if (this.$route.query.genename) {
        genename = this.$route.query.genename;
      }
      if (genename) {
        await getGencodeGenePatternByGenename(genename)
          .then((result) => {
            if (result) {
              this.gene_start = result[0].start;
              // console.log(this.gene_start);
              this.gene_end = result[0].end;
              // console.log(this.gene_end);
              this.strand = result[0].strand;
              // console.log(this.strand);
              let transcript = result[0]["transcript"];

              let all_transcript = [];
              Object.keys(transcript)
                .sort()
                .map((d) => all_transcript.push(transcript[d]));
              // console.log(all_transcript);
              result[0]["transcript"] = all_transcript; // replaced as sorted transcript
              this.gencodeGenePattern = result;

              this.transcript = all_transcript;
              // console.log(this.transcript)

              // get all exons coordinate
              let all_tx_exon = [];
              // get all utr coordinate
              let all_tx_utr = [];
              // get all start_codon coordinate
              let all_start_codon = [];
              // get all stop_codon coordinate
              let all_stop_codon = [];
              all_transcript &&
                all_transcript.forEach((value, index, array) => {
                  value.exons.forEach((v, i, a) => {
                    let tx_exon = {};
                    tx_exon["exon_number"] = v.exon_number;
                    tx_exon["exon_id"] = v.exon_id;
                    tx_exon["chr"] = v.chr;
                    tx_exon["start"] = v.start;
                    tx_exon["end"] = v.end;
                    tx_exon["length"] = v.length;
                    tx_exon["strand"] = v.strand;
                    tx_exon["tx"] = value.transcript_name;
                    all_tx_exon.push(tx_exon); // 注意：此处不能写 this.all_tx_exon.push(tx_exon) ,否则 all_tx_exon 会进行不断叠加
                  });

                  value.utr.forEach((v, i, a) => {
                    let tx_utr = {};
                    tx_utr["chr"] = v.chr;
                    tx_utr["start"] = v.start;
                    tx_utr["end"] = v.end;
                    tx_utr["length"] = v.length;
                    tx_utr["strand"] = v.strand;
                    tx_utr["tx"] = value.transcript_name;
                    all_tx_utr.push(tx_utr);
                  });

                  value.start_codon.forEach((v, i, a) => {
                    let start_codon = {};
                    start_codon["chr"] = v.chr;
                    start_codon["start"] = v.start;
                    start_codon["end"] = v.end;
                    start_codon["length"] = v.length;
                    start_codon["strand"] = v.strand;
                    start_codon["tx"] = value.transcript_name;
                    all_start_codon.push(start_codon);
                  });

                  value.stop_codon.forEach((v, i, a) => {
                    let stop_codon = {};
                    stop_codon["chr"] = v.chr;
                    stop_codon["start"] = v.start;
                    stop_codon["end"] = v.end;
                    stop_codon["length"] = v.length;
                    stop_codon["strand"] = v.strand;
                    stop_codon["tx"] = value.transcript_name;
                    all_stop_codon.push(stop_codon);
                  });
                });
              this.all_tx_exon = all_tx_exon;
              // console.log(this.all_tx_exon);
              this.all_tx_utr = all_tx_utr;
              // console.log(this.all_tx_utr);
              this.all_start_codon = all_start_codon;
              // console.log(this.all_start_codon);
              this.all_stop_codon = all_stop_codon;
              // console.log(this.all_stop_codon);

              // get all introns coordinate
              let all_tx_intron = [];
              all_transcript &&
                all_transcript.forEach((value, index, array) => {
                  value.exons.forEach((v, i, a) => {
                    if (i < value.exons.length - 1 && v.strand == "+") {
                      let tx_intron = {};
                      tx_intron["start"] = v.end;
                      tx_intron["end"] = a[i + 1].start;
                      tx_intron["tx"] = value.transcript_name;
                      all_tx_intron.push(tx_intron);
                    }

                    if (i < value.exons.length - 1 && v.strand == "-") {
                      let tx_intron = {};
                      tx_intron["end"] = v.start;
                      tx_intron["start"] = a[i + 1].end;
                      tx_intron["tx"] = value.transcript_name;
                      all_tx_intron.push(tx_intron);
                    }
                  });
                });
              this.all_tx_intron = all_tx_intron;
              // console.log(this.all_tx_intron);
            }
          })
          .catch((err) => {
            console.error("There is no gencode gene pattern of", genename);
          });
      }
    },
    async initTxStructure() {
      const margin = { top: 0, right: 30, bottom: 20, left: 45 };
      const width = 400;
      const exonColor = "#42A5F5";
      const hoverColor = "#eec42d";
      const utrColor = "white";
      const rectHeight = 6;

      // request data (getGencodeGenePatternByGenename)
      let all_transcript_numbers,
        height,
        start,
        end,
        strand,
        exons,
        introns,
        utrs,
        start_codons,
        stop_codons;
      await this.getGencodeGenePatternByGenename().then(() => {
        all_transcript_numbers = this.transcript.length;
        height = 10 * all_transcript_numbers + margin.top + margin.bottom;
        start = this.gene_start;
        end = this.gene_end;
        strand = this.strand;
        exons = this.all_tx_exon;
        // console.log(exons.length);
        introns = this.all_tx_intron;
        // console.log(introns.length);
        utrs = this.all_tx_utr;
        // console.log(utrs.length);
        start_codons = this.all_start_codon;
        stop_codons = this.all_stop_codon;
      });
      // console.log(height);

      // This place can't be d3.select("svg"), because of conflicting with D3 chart svg.
      const svg = d3
        .select("div#allIsoform > svg")
        .attr("viewBox", [0, 0, width, height])
        .on("click", reSet);

      const zoomin = d3.select(".zoomin");
      zoomin.on("click", zoomIn);
      const zoomout = d3.select(".zoomout");
      zoomout.on("click", zoomOut);
      const reset = d3.select(".reset");
      reset.on("click", reSet);

      // add tooltips
      let tooltip = d3
        .select("body")
        .append("div")
        .attr("class", "d3-tooltip")
        .style("position", "absolute")
        .style("z-index", "10")
        .style("visibility", "hidden")
        .style("padding", "10px")
        .style("background", "rgba(0,0,0,0.6)")
        .style("border-radius", "4px")
        .style("color", "#fff")
        .text("a simple tooltip");

      // Clip Off Zoom Overflow
      svg
        .append("clipPath")
        .attr("id", "clipRect")
        .append("rect")
        .attr("x", margin.left - 1)
        .attr("y", margin.top)
        .attr("width", width - margin.left - margin.right + 1)
        .attr("height", height);

      // plot X axis
      let xScale = d3
        .scaleLinear()
        .domain([start, end])
        .range([margin.left, width - margin.right]);
      let xAxis = d3
        .axisBottom(xScale)
        .tickSize(2)
        .tickSizeOuter(0)
        .tickPadding(1)
        .tickFormat((x) => x);
      svg
        .append("g")
        .attr("class", "x-axis")
        .attr("transform", `translate(0,${height - margin.bottom})`)
        .call(xAxis)
        .call((g) => g.selectAll(".domain").attr("stroke-width", "0.3")) // x 轴
        .call((g) => g.selectAll(".tick line").attr("stroke-width", "0.3")) // x 轴 刻度线
        .call((g) =>
          g
            .selectAll(".tick text")
            .attr("font-size", "4")
            .attr("font-family", "Arial")
        ) // x 轴 刻度文字
        .attr("clip-path", "url(#clipRect)");

      // plot Y axis
      // sort function based on tx id, in order to sort the y-axis transcript_name
      let compare = function (obj1, obj2) {
        let val1 = obj1.tx;
        let val2 = obj2.tx;
        // 注意：此处不能写成 return val1 - val2
        if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          return 0;
        }
      };
      // console.log(exons.sort(compare));
      exons.sort(compare);

      let yScale = d3
        .scaleBand()
        .domain(
          exons.map(function (d) {
            return d.tx;
          })
        )
        .range([height - margin.bottom, margin.top])
        .padding(1);
      let yAxis = d3.axisLeft(yScale);
      svg
        .append("g")
        .attr("class", "y-axis")
        .attr("transform", `translate(${margin.left},${rectHeight / 2})`)
        .call(yAxis)
        .call((g) => g.select(".domain").remove())
        .call((g) => g.selectAll(".tick line").remove())
        .call((g) =>
          g
            .selectAll(".tick text")
            .attr("font-size", "4")
            .attr("font-family", "Arial")
        );

      // plot exons rects
      svg
        .append("g")
        .attr("class", "exons")
        .selectAll()
        .data(exons)
        .join("rect")
        .attr("x", (d) => xScale(d.start))
        .attr("y", (d) => yScale(d.tx))
        .attr("width", (d) => xScale(d.end) - xScale(d.start))
        .attr("height", rectHeight)
        .attr("rx", 1) // set border-radius
        .attr("stroke", "rgb(0,0,0)") // set border color
        .attr("stroke-width", 0.3) // set border width
        .attr("fill", exonColor)
        .attr("clip-path", "url(#clipRect)")
        .on("mouseover", function () {
          d3.select(this).transition().attr("fill", hoverColor);
        })
        .on("mouseout", function () {
          d3.select(this).transition().attr("fill", exonColor);
        });
      // .on('mouseover', function (event, d) {
      //   // console.log(event, d);
      //   tooltip.html(`<div>Number: ${d.exon_number}</div>
      //       <div>ID: ${d.exon_id.split('.')[0]}</div>
      //       <div>Chr: ${d.chr}</div>
      //       <div>Start: ${d.start}</div>
      //       <div>End: ${d.end}</div>
      //       <div>Length: ${d.length}</div>`)
      //     .style('visibility', 'visible')
      //     .style("font-family", "Arial")
      //   d3.select(this).transition().attr('fill', hoverColor);
      // })
      // .on('mousemove', () => {
      //   tooltip.style('top', event.pageY - 10 + 'px')
      //     .style('left', event.pageX + 10 + 'px')
      // })
      // .on('mouseout', function () {
      //   tooltip.html(``).style('visibility', 'hidden');
      //   d3.select(this).transition().attr('fill', exonColor);
      // });
      // add exons tooltips using Tippy.js
      let exon_rects = d3.selectAll(".exons rect");
      exon_rects.attr("data-tippy-content", (d, i) => {
        return `<div>Exon Number: ${d.exon_number}</div>
             <div>Exon ID: ${d.exon_id.split(".")[0]}</div>
             <div>Chr: ${d.chr}</div>
             <div>Start: ${d.start}</div>
             <div>End: ${d.end}</div>
             <div>Length: ${d.length}</div>`;
      });
      tippy(exon_rects.nodes(), {
        allowHTML: true,
        placement: "right",
        interactive: true,
        interactiveDebounce: 0,
        appendTo: () => document.body,
        // followCursor: 'horizontal',
        // plugins: [followCursor],
        maxWidth: 200,
        delay: 0,
        duration: [0, 0],
      });

      // plot introns lines
      svg
        .append("g")
        .attr("class", "introns")
        .selectAll()
        .data(introns)
        .join("line")
        .attr("x1", (d) => xScale(d.start))
        .attr("y1", (d) => yScale(d.tx))
        .attr("x2", (d) => xScale(d.end))
        .attr("y2", (d) => yScale(d.tx))
        .attr("transform", `translate(0,${rectHeight / 2})`)
        .attr("stroke", "grey")
        .attr("stroke-width", "0.5")
        .attr("clip-path", "url(#clipRect)");

      // plot utrs rects
      svg
        .append("g")
        .attr("class", "utrs")
        .selectAll()
        .data(utrs)
        .join("rect")
        .attr("x", (d) => xScale(d.start))
        .attr("y", (d) => yScale(d.tx))
        .attr("width", (d) => xScale(d.end) - xScale(d.start))
        .attr("height", rectHeight / 2)
        .attr("transform", `translate(0,${rectHeight / 4})`)
        .attr("rx", 0.5) // set border-radius
        .attr("stroke", "rgb(0,0,0)") // set border color
        .attr("stroke-width", 0.3) // set border width
        .attr("fill", utrColor)
        .attr("clip-path", "url(#clipRect)")
        .on("mouseover", function () {
          d3.select(this).transition().attr("fill", hoverColor);
        })
        .on("mouseout", function () {
          d3.select(this).transition().attr("fill", utrColor);
        });
      // add utrs tooltips using Tippy.js
      let utr_rects = d3.selectAll(".utrs rect");
      utr_rects.attr("data-tippy-content", (d, i) => {
        return `<div>UTR</div>
             <div>Chr: ${d.chr}</div>
             <div>Strand: ${d.strand}</div>
             <div>Start: ${d.start}</div>
             <div>End: ${d.end}</div>
             <div>Length: ${d.length}</div>`;
      });
      tippy(utr_rects.nodes(), {
        allowHTML: true,
        placement: "right",
        interactive: true,
        interactiveDebounce: 0,
        appendTo: () => document.body,
        // followCursor: 'horizontal',
        // plugins: [followCursor],
        maxWidth: 200,
        delay: 0,
        duration: [0, 0],
      });

      // plot start_codon
      svg
        .append("g")
        .attr("class", "start-codons")
        .selectAll()
        .data(start_codons)
        .join("circle")
        .attr("cx", (d) => xScale(d.start + 1))
        .attr("cy", (d) => yScale(d.tx) + 3)
        .attr("r", 0.8)
        .attr("fill", "red")
        .attr("stroke", "black")
        .attr("stroke-width", "0.3")
        .attr("clip-path", "url(#clipRect)")
        .on("mouseover", function () {
          d3.select(this)
            .transition()
            .attr("fill", hoverColor)
            .attr("r", 2)
            .attr("stroke-width", "0.5");
        })
        .on("mouseout", function () {
          d3.select(this)
            .transition()
            .attr("fill", "red")
            .attr("r", 0.8)
            .attr("stroke-width", "0.3");
        });
      // add start_codons tooltips using Tippy.js
      let start_codon = d3.selectAll(".start-codons circle");
      start_codon.attr("data-tippy-content", (d, i) => {
        return `<div>Start Codon</div>
             <div>Chr: ${d.chr}</div>
             <div>Strand: ${d.strand}</div>
             <div>Start: ${d.start}</div>
             <div>End: ${d.end}</div>`;
      });
      tippy(start_codon.nodes(), {
        allowHTML: true,
        placement: "right",
        interactive: true,
        interactiveDebounce: 0,
        appendTo: () => document.body,
        // followCursor: 'horizontal',
        // plugins: [followCursor],
        maxWidth: 200,
        delay: 0,
        duration: [0, 0],
      });

      // plot stop_codon
      svg
        .append("g")
        .attr("class", "stop-codons")
        .selectAll()
        .data(stop_codons)
        .join("circle")
        .attr("cx", (d) => xScale(d.start + 1))
        .attr("cy", (d) => yScale(d.tx) + 3)
        .attr("r", 0.8)
        .attr("fill", "red")
        .attr("stroke", "black")
        .attr("stroke-width", "0.3")
        .attr("clip-path", "url(#clipRect)")
        .on("mouseover", function () {
          d3.select(this)
            .transition()
            .attr("fill", hoverColor)
            .attr("r", 2)
            .attr("stroke-width", "0.5");
        })
        .on("mouseout", function () {
          d3.select(this)
            .transition()
            .attr("fill", "red")
            .attr("r", 0.8)
            .attr("stroke-width", "0.3");
        });
      // add stop_codons tooltips using Tippy.js
      let stop_codon = d3.selectAll(".stop-codons circle");
      stop_codon.attr("data-tippy-content", (d, i) => {
        return `<div>Stop Codon</div>
             <div>Chr: ${d.chr}</div>
             <div>Strand: ${d.strand}</div>
             <div>Start: ${d.start}</div>
             <div>End: ${d.end}</div>`;
      });
      tippy(stop_codon.nodes(), {
        allowHTML: true,
        placement: "right",
        interactive: true,
        interactiveDebounce: 0,
        appendTo: () => document.body,
        // followCursor: 'horizontal',
        // plugins: [followCursor],
        maxWidth: 200,
        delay: 0,
        duration: [0, 0],
      });

      // paint the legend
      svg
        .append("g")
        .attr("class", "legend-background")
        .append("rect")
        .attr("x", margin.left + 85)
        .attr("y", height - margin.bottom + 8)
        .attr("width", 135)
        .attr("height", 10)
        .attr("rx", 1) // set border-radius
        .attr("stroke", "rgb(0,0,0)") // set border color
        .attr("stroke-dasharray", "1,1") // set border color
        .attr("stroke-width", 0.3) // set border width
        .attr("fill", "#F5F5F5");
      // paint the legend-exon
      svg
        .append("g")
        .attr("class", "legend-exon")
        .append("rect")
        .attr("x", margin.left + 90)
        .attr("y", height - margin.bottom + 10)
        .attr("width", 10)
        .attr("height", 6)
        .attr("rx", 1)
        .attr("stroke", "rgb(0,0,0)")
        .attr("stroke-width", 0.3)
        .attr("fill", exonColor);
      // paint the legend-exon-text
      svg
        .append("g")
        .attr("class", "legend-exon-text")
        .append("text")
        .attr("x", margin.left + 90 + 15)
        .attr("y", height - margin.bottom + 14)
        .text("Exon")
        .attr("font-size", 4)
        .attr("font-family", "Arial");

      // paint the legend-utr
      svg
        .append("g")
        .attr("class", "legend-utr")
        .append("rect")
        .attr("x", margin.left + 105 + 20)
        .attr("y", height - margin.bottom + 11)
        .attr("width", 10)
        .attr("height", 4)
        .attr("rx", 0.5)
        .attr("stroke", "rgb(0,0,0)")
        .attr("stroke-width", 0.3)
        .attr("fill", utrColor);
      // paint the legend-utr-text
      svg
        .append("g")
        .attr("class", "legend-utr-text")
        .append("text")
        .attr("x", margin.left + 125 + 15)
        .attr("y", height - margin.bottom + 14)
        .text("UTR")
        .attr("font-size", 4)
        .attr("font-family", "Arial");

      // paint the legend-codon
      svg
        .append("g")
        .attr("class", "legend-codon")
        .append("circle")
        .attr("cx", margin.left + 140 + 20)
        .attr("cy", height - margin.bottom + 13)
        .attr("r", 1)
        .attr("fill", "red")
        .attr("stroke", "black")
        .attr("stroke-width", "0.3");
      // paint the legend-codon-text
      svg
        .append("g")
        .attr("class", "legend-codon-text")
        .append("text")
        .attr("x", margin.left + 160 + 6)
        .attr("y", height - margin.bottom + 14)
        .text("Codon")
        .attr("font-size", 4)
        .attr("font-family", "Arial");

      // paint the legend-intron
      svg
        .append("g")
        .attr("class", "legend-intron")
        .append("line")
        .attr("x1", margin.left + 166 + 20)
        .attr("y1", height - margin.bottom + 13)
        .attr("x2", margin.left + 166 + 30)
        .attr("y2", height - margin.bottom + 13)
        .attr("stroke", "grey")
        .attr("stroke-width", "0.5px");
      // paint the legend-intron-text
      svg
        .append("g")
        .attr("class", "legend-intron-text")
        .append("text")
        .attr("x", margin.left + 196 + 5)
        .attr("y", height - margin.bottom + 14)
        .text("Intron")
        .attr("font-size", 4)
        .attr("font-family", "Arial");

      // paint arrow
      svg
        .append("g")
        .append("marker")
        .attr("id", "arrow")
        .attr("markerUnits", "strokeWidth") //设置为strokeWidth箭头会随着线的粗细发生变化
        .attr("viewBox", "0 0 10 10") //坐标系的区域
        .attr("refX", 6) //箭头坐标
        .attr("refY", 6)
        .attr("markerWidth", 12)
        .attr("markerHeight", 12)
        // .attr("orient", "auto") //绘制方向，可设定为：auto（自动确认方向）和 角度值
        .attr("orient", "auto-start-reverse") //绘制方向，可设定为：auto-start-reverse 和 角度值
        .append("path")
        .attr("d", "M2,2 L10,6 L2,10 L6,6 L2,2") //箭头的路径
        .attr("fill", "black") //箭头颜色
        .attr("opacity", 0.5);

      // 绘制与箭头相连的直线
      let arrowline = svg
        .append("g")
        .append("line")
        .attr("x1", margin.left)
        .attr("y1", margin.top + 5)
        .attr("x2", width - margin.right)
        .attr("y2", margin.top + 5)
        .attr("fill", "none")
        .attr("stroke", "black")
        .attr("stroke-width", 0.5)
        .attr("stroke-opacity", 0.5)
        .attr("stroke-dasharray", (6, 5));
      // .attr("marker-start", "url(#arrow)");

      // 根据正负链判断箭头方向，并在箭头上方添加文字
      // console.log(strand);
      if (strand == "+") {
        arrowline.attr("marker-end", "url(#arrow)");
        svg
          .append("g")
          .append("text")
          .attr("x", margin.left)
          .attr("y", margin.top + 3)
          .text("5'")
          .attr("font-size", 4)
          .attr("opacity", 0.5);
        svg
          .append("g")
          .append("text")
          .attr("x", width - margin.right - 8)
          .attr("y", margin.top + 3)
          .text("3'")
          .attr("font-size", 4)
          .attr("opacity", 0.5);
      } else {
        arrowline.attr("marker-start", "url(#arrow)");
        svg
          .append("g")
          .append("text")
          .attr("x", margin.left)
          .attr("y", margin.top + 3)
          .text("3'")
          .attr("font-size", 4)
          .attr("opacity", 0.5);
        svg
          .append("g")
          .append("text")
          .attr("x", width - margin.right - 8)
          .attr("y", margin.top + 3)
          .text("5'")
          .attr("font-size", 4)
          .attr("opacity", 0.5);
      }

      // zoom
      let extent = [
        [margin.left, margin.top],
        [width - margin.right, height - margin.top],
      ];
      let zoom = d3
        .zoom()
        .scaleExtent([1, 8])
        .translateExtent(extent)
        .extent(extent)
        .on("zoom", zoomed);

      svg.call(zoom).on("wheel.zoom", null); // disable zoom on scrollwheel

      function zoomed(event) {
        xScale.range(
          [margin.left, width - margin.right].map((d) =>
            event.transform.applyX(d)
          )
        );
        svg.select(".x-axis").call(xAxis);
        svg
          .selectAll(".exons rect")
          .attr("x", (d) => xScale(d.start))
          .attr("y", (d) => yScale(d.tx))
          .attr("width", (d) => xScale(d.end) - xScale(d.start));
        svg
          .selectAll(".introns line")
          .attr("x1", (d) => xScale(d.start))
          .attr("x2", (d) => xScale(d.end));
        svg
          .selectAll(".utrs rect")
          .attr("x", (d) => xScale(d.start))
          .attr("y", (d) => yScale(d.tx))
          .attr("width", (d) => xScale(d.end) - xScale(d.start));
        svg
          .selectAll(".start-codons circle")
          .attr("cx", (d) => xScale(d.start + 1));
        svg
          .selectAll(".stop-codons circle")
          .attr("cx", (d) => xScale(d.start + 1));
      }

      function zoomIn() {
        // console.log('click zoom in');
        svg.transition().duration(400).call(zoom.scaleBy, 2);
      }

      function zoomOut() {
        // console.log('click zoom out');
        svg.transition().duration(400).call(zoom.scaleBy, 0.5);
      }

      function reSet() {
        // console.log('click reset');
        svg
          .transition()
          .duration(750)
          .call(
            zoom.transform,
            d3.zoomIdentity,
            d3.zoomTransform(svg.node()).invert([width / 2, height / 2])
          );
      }
    },
    svgToPdfExample(svg, name) {
      const doc = new window.PDFDocument();
      const chunks = [];
      const stream = doc.pipe({
        // writable stream implementation
        write: (chunk) => chunks.push(chunk),
        end: () => {
          const pdfBlob = new Blob(chunks, {
            type: "application/octet-stream",
          });
          var blobUrl = URL.createObjectURL(pdfBlob);
          //window.open(`${blobUrl}?customfilename.pdf`);

          /* custom file name download */
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = blobUrl;
          a.download = name; // <---- 👈 file name
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        },
        // readable streaaam stub iplementation
        on: (event, action) => { },
        once: (...args) => { },
        emit: (...args) => { },
      });

      window.SVGtoPDF(doc, svg, 0, 0, { useCSS: true });
      doc.end();
    },
    downloadTranscript() {
      // console.log('download');
      let svg = d3.select("div#allIsoform > svg")._groups[0][0];
      // console.log(svg);
      let name = this.gene_select + "_Transcript.pdf";
      this.svgToPdfExample(svg, name);
    },
  },
};
</script>
<style scoped></style>